import type { ReactNode } from 'react';
import { DM_ACTION_COLUMN } from './DmControlPrimitives';
import { OneLineNotice } from './OneLineNotice';

interface ConfirmLayoutProps {
    children: ReactNode;
    cancel: ReactNode;
    confirm: ReactNode;
    /** DM's refusal, on a line always kept free; the full text is in a tooltip. */
    error?: string | null;
    /** Let the content grow into the free space (e.g. a message box) instead of centring in it. */
    fill?: boolean;
}

// A confirm step at the idle buttons' width: the content centred in the free space, then the error
// line, then Cancel at the left edge and the action at the right, pinned to the bottom.
export function ConfirmLayout({
    children,
    cancel,
    confirm,
    error = null,
    fill = false
}: ConfirmLayoutProps) {
    return (
        <div className={`${DM_ACTION_COLUMN} flex flex-1 flex-col`}>
            <div className={`flex min-h-0 flex-1 flex-col gap-2 ${fill ? '' : 'justify-center'}`}>
                {children}
            </div>
            <OneLineNotice message={error} fromDm className="mt-1" />
            <div className="flex items-center justify-between gap-2 pt-2">
                {cancel}
                {confirm}
            </div>
        </div>
    );
}
